import {
  ADDON_PRODUCT_DWH_PREPAID_UNITS_DEFAULT,
  ADDON_PRODUCT_DWH_PREPAID_UNITS_MIN,
} from "@stores/addons/constants";
import { formatPrice, formatQuantity } from "@common/utils/string";
import { offerDWHRent } from "@stores/config/utils";
import { HOSTING_FEATURE_CLICKHOUSE_DWH } from "@stores/subscriptions/constants";
import { ManageCard } from "./ManageCard";
import {
  hasStorage,
  prepaidEstimate,
  prepaidTotal,
  subscribedUnits,
} from "../utils";
import {
  IAddOnContext,
  IUpsertContext,
  IPrepaidAddOnDescriptor,
} from "../types";

const rows = (n: number): string => `${formatQuantity(n)} stored rows`;

const dwh = {
  productType: "dwh",
  kind: "prepaid",
  title: "Storage",

  isVisible: (ctx: IAddOnContext) =>
    ctx.isCloudHosted &&
    (!!ctx.subscribed || (!hasStorage(ctx) && !offerDWHRent(ctx.config))),

  getUsage: ({ purchase, subscribed }: IAddOnContext) => {
    if (!subscribed) {
      return undefined;
    }

    const quota = purchase.quota?.[HOSTING_FEATURE_CLICKHOUSE_DWH]?.rows;

    return {
      hasQuota: !!quota,
      usage: quota?.usage ?? 0,
      includedUnits: subscribed.prepaid_units,
    };
  },

  getEstimateRowItem: (ctx, units) => ({
    detail: rows(units),
    price: prepaidEstimate(ctx, units),
  }),

  getUpsertAddOns: (ctx: IUpsertContext, units: number) => [
    {
      product_type: "dwh",
      prepaid_units:
        units < ADDON_PRODUCT_DWH_PREPAID_UNITS_MIN
          ? ADDON_PRODUCT_DWH_PREPAID_UNITS_DEFAULT
          : units,
    },
    ...ctx.getUpsertAddOnsFor("etl-connections"),
  ],

  getBillingRowItem: (ctx) => ({ detail: rows(subscribedUnits(ctx)) }),
  getPurchaseLineItem: (ctx) => {
    const { subscribed } = ctx;

    if (!subscribed) {
      return undefined;
    }

    const usage = ctx.getUsage();
    const total = prepaidTotal(ctx);

    return {
      detail: `${usage?.hasQuota ? `${formatQuantity(usage.usage)}/` : ""}${rows(subscribed.prepaid_units)}`,
      price: total === null ? undefined : formatPrice(total),
    };
  },

  ManageCard,
} satisfies IPrepaidAddOnDescriptor;

export default dwh;
